module.exports = __webpack_public_path__ + "img/copy-regular.9bb4a184.svg";